import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronArrowDown, ChevronArrowUp, Comparison, JetliftSizing, Reports } from "../../../../assets/icons";
import { calculateButtonOptions, equipmentOptions } from "../../../../constants/columns/projectdetails/buttonGroup"
import useJetliftProjectHeaderFacade from "../../../../facade/jetlift/project-header/projectHeader.facade";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import CaseCards from "../../../jetlift/case-cards";
import ButtonGroup from "../../button-group";
import Button from "../../text-button-group"
import Select from "../Select";
import Dropdown from "../../dropdown";
import { LABELS } from "../../../../constants/labels/jetlift/jetlift.labels";
import { createJetliftCase, deleteJetliftCase } from "../../../../services/jetlift/jetliftCalculations.service";
import { showToast, updateCaseName } from "../../../../utilities/commonUtilities";
import { caseDetailsPayload } from "../../../../models/Myprojects";
import useJetliftTubingFacade from "../../../../facade/jetlift/jetlift-input/tubing.facade";
import useCreateProjectFacade from "../../../../facade/createProject.Facade";
import { ProjectStatus } from "../../../../utilities/AppConstants";
import { designType } from "../../../../utilities/CasingConstant";
import { updateCaseDetails } from "../../../../services/project.service";
import useProjectHeaderFacade from "../../../../facade/calculation/calculation-input/projectHeader.facade";
import useJetliftCalculationFacade from "../../../../facade/jetlift/jetliftCalculations.facade";
import useProjectFacade from "../../../../facade/project.Facade";
import useJetliftComparisonFacade from "../../../../facade/jetlift/comparison/comparison.facade";
import { toast } from "react-toastify";

interface ProjectHeaderProps {
    onCalculate?: () => void;
};

const ProjectHeader: React.FC<ProjectHeaderProps> = ({ onCalculate }) => {
    const { isJetlift, isComparison, isReports } = useAppSelector((state) => state?.jetlift?.projectHeader);
    const { tubingInput } = useAppSelector((state) => state?.jetlift?.tubing);
    const { projectAndAffiliations, projectsCache } = useAppSelector((state) => state?.projectHeader);
    const { customerEnabled } = useAppSelector((state) => state?.auth);
    const { tab4Input } = useAppSelector(state => state?.projectTab);
    const { sharedCases, selectedProject } = useAppSelector((state) => state?.myProjects);
    const { compareInput1, compareInput2, compareInput3 } = useAppSelector((state) => state?.jetlift?.comparison);
    const { loading } = useAppSelector((state) => state?.jetlift?.calculations);
    const { updateIsJetlift, updateIsComparison, updateIsReports } = useJetliftProjectHeaderFacade();
    const { updateLiftOption } = useCreateProjectFacade();
    const { updateCatalogType } = useJetliftTubingFacade();
    const { getProjectAndAffiliationsDetails } = useProjectHeaderFacade();
    const { CopyJetliftProject, getJetliftCalculations } = useJetliftCalculationFacade();
    const { createNewCase, copyMyProjects, getUpdatedSelectedProject } = useProjectFacade();
    const {
        updateComparisonInput1,
        updateComparisonInput2,
        updateComparisonInput3,
        loadJetliftComparisonData,
    } = useJetliftComparisonFacade();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [activeActionItem, setActiveActionItem] = useState(0);
    const [activeCase, setActiveCase] = useState<{ index: number, case: any }>({ index: 0, case: {} });
    const [filteredAffiliations, setFilteredAffiliations] = useState<any[]>([]);
    const { ID, caseID } = useParams();
    const parentProjectID = ID?.split("projectID=")?.[1];
    const caseId = caseID === undefined ? "" : caseID?.split("caseID=")?.[1];
    const templateId = ID?.split("templateID=")?.[1];
    const navigate = useNavigate();
    const filteredProjectandAffiliations = projectAndAffiliations?.filter((item: any) => item?.liftType === 2);
    const case1ProductionOptions = filteredProjectandAffiliations?.map((x: any, index: number) => ({
        id: x.projectID, name: `Case ${index + 1}: ${x.caseName}`
    }));
    const case2ProductionOptions = filteredProjectandAffiliations
        ?.filter((item: any) =>
            customerEnabled
                ? (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(item.projectID)) ||
                (
                    typeof item?.userRole === "string" &&
                    item?.userRole?.trim().toLowerCase()?.includes("customer") &&
                    typeof item.companyName === "string" &&
                    typeof tab4Input?.companyName === "string" &&
                    item.companyName.trim().toLowerCase() === tab4Input.companyName.trim().toLowerCase()
                )
                : true
        )
        ?.map((x: any, index: number) => ({
            id: x.projectID, name: `${x.displayCaseName}: ${x.caseName}`
        }))
        ?.filter((x: any) => x.id !== compareInput1);

    const case3ProductionOptions = filteredProjectandAffiliations
        ?.filter((item: any) =>
            customerEnabled
                ? (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(item.projectID)) ||
                (
                    typeof item?.userRole === "string" &&
                    item?.userRole?.trim().toLowerCase()?.includes("customer") &&
                    typeof item.companyName === "string" &&
                    typeof tab4Input?.companyName === "string" &&
                    item.companyName.trim().toLowerCase() === tab4Input.companyName.trim().toLowerCase()
                )
                : true
        )
        ?.map((x: any, index: number) => ({
            id: x.projectID, name: `${x.displayCaseName}: ${x.caseName}`
        }))
        ?.filter((x: any) => ![compareInput1, compareInput2].includes(x.id));

    useEffect(() => {
        if (projectAndAffiliations?.length > 0) {
            const filtered = projectAndAffiliations?.filter((x: any) => {
                if (customerEnabled) {
                    return (
                        (sharedCases?.length > 0 && sharedCases[0]?.case?.includes(x.projectID)) ||
                        (
                            typeof x?.userRole === "string" &&
                            x?.userRole?.trim().toLowerCase()?.includes("customer") &&
                            typeof x.companyName === "string" &&
                            typeof tab4Input?.companyName === "string" &&
                            x.companyName.trim().toLowerCase() === tab4Input.companyName.trim().toLowerCase()
                        )
                    );
                }
                return true;
            });
            setFilteredAffiliations(filtered);

            if (filtered?.length > 0) {
                const caseIndex = filtered?.findIndex((x: any) => x?.projectID === caseId);
                const caseName = filtered?.find((x: any) => x?.projectID === caseId);
                const projectName = filtered?.[0];
                if (caseIndex !== -1 && caseId !== "") {
                    setActiveCase((prev) => ({ ...prev, index: caseIndex, case: caseName }));
                } else {
                    setActiveCase((prev) => ({ ...prev, index: 0, case: projectName }));
                }
            } else {
                setFilteredAffiliations([]);
                setActiveCase({ index: 0, case: {} });
            }
        } else {
            setFilteredAffiliations([]);
            setActiveCase({ index: 0, case: {} });
        }
    }, [projectAndAffiliations, sharedCases, tab4Input?.companyName, caseId, customerEnabled]);

    useEffect(() => {
        if (isComparison) {
            const input1 = case1ProductionOptions?.filter((x: any) => x?.id === parentProjectID);
            const input2 = case2ProductionOptions?.filter((x: any) => x?.id === compareInput2);
            const input3 = case3ProductionOptions?.filter((x: any) => x?.id === compareInput3);
            updateComparisonInput1(input1?.[0]?.id);
            updateComparisonInput2(input2?.[0]?.id);
            updateComparisonInput3(input3?.[0]?.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isComparison]);

    const onCompare = async () => {
        const selectedProjects = [compareInput1, compareInput2, compareInput3].filter(value => value);
        const cacheData = projectsCache ? Object.keys(projectsCache) : [];
        const newProjects = selectedProjects.filter(x => !cacheData.includes(x));
        const compareResult: any = [];
        let items = { ...(projectsCache as any) };
        if (newProjects?.length) {
            var result: any = "";
            if (result?.meta?.requestStatus === "fulfilled" && result.payload) {
                items = { ...(result.payload as any), ...(projectsCache as any) }
            }
        }
        selectedProjects.forEach((key: string | number) => {
            compareResult.push(items[key]);
        });
        loadJetliftComparisonData();
    };

    const clearCompareInputs1 = (id: string) => {
        if (id === compareInput2) updateComparisonInput2("");
        if (id === compareInput3) updateComparisonInput3("");
        updateComparisonInput1(id)
    };

    const clearCompareInputs2 = (id: string) => {
        if (id === compareInput1) updateComparisonInput1("");
        if (id === compareInput3) updateComparisonInput3("");
        updateComparisonInput2(id);
        onCompare();
    };

    const clearCompareInputs3 = (id: string) => {
        if (id === compareInput2) updateComparisonInput2("");
        if (id === compareInput1) updateComparisonInput1("");
        updateComparisonInput3(id);
        onCompare();
    };

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleClick = (option: any) => {
        if (option === "Jet lift sizing") {
            updateIsJetlift(true);
            updateIsComparison(false);
            updateIsReports(false);
        } else if (option === "Comparison") {
            updateIsJetlift(false);
            updateIsComparison(true);
            updateIsReports(false);
        } else if (option === "Reports") {
            updateIsJetlift(false);
            updateIsComparison(false);
            updateIsReports(true);
        }
    };

    const projectHeaderButtonOptions = [
        { id: 1, icon: <JetliftSizing color={isJetlift ? "#60BFDA" : "#F7F9F9"} />, label: "Jet lift sizing", type: "primary", width: "[50%]" },
        { id: 2, icon: <Comparison color={isComparison ? "#60BFDA" : "#F7F9F9"} />, label: "Comparison", type: "primary", disabled: templateId, width: "[25%]" },
        { id: 3, icon: <Reports color={isReports ? "#60BFDA" : "#F7F9F9"} />, label: "Reports", type: "primary", disabled: templateId || loading, width: "[25%]" },
    ];

    const handleCaseDialogCreate = async (payload: caseDetailsPayload) => {
        try {
            const parentCase = filteredAffiliations?.find((x: any) => x.projectID === parentProjectID);
            if (parentCase) {
                if (payload?.caseModalMode === "update") {
                    const projectId = projectAndAffiliations[activeActionItem]?.projectID;
                    const casePayload: any = {
                        caseName: payload.caseName,
                        caseDescription: payload.caseDescription,
                    };
                    const response = await updateCaseDetails(projectId, casePayload);
                    if (response) {
                        showToast("Case updated successfully.", "success");
                        await getProjectAndAffiliationsDetails(parentProjectID || "");
                    }
                } else {
                    let caseName = updateCaseName("", false, filteredAffiliations);
                    const casePayload: any = {
                        ...parentCase,
                        projectID: '',
                        parentId: parentCase?.projectID,
                        ...payload,
                        DisplayCaseName: caseName,
                        copyFrom: null,
                        liftType: payload?.liftType === 'ESP' ? 1 : 2
                    };
                    let response;
                    if (payload?.liftType === 'Jet lift') {
                        response = await createJetliftCase(casePayload);
                    } else if (payload?.liftType === 'ESP') {
                        response = await createNewCase({ ...parentCase, projectID: '', parentId: parentCase?.projectID, ...payload, DisplayCaseName: caseName, copyFrom: null, liftType: 1 });
                    }
                    if (response) {
                        showToast("Case created successfully.", "success");
                        setActiveActionItem(0);
                        await getProjectAndAffiliationsDetails(parentProjectID || "");
                    }
                }

            }
        } catch (err) {
            console.error("Error creating case:", err);
            showToast("Error creating/updating case.", "error");
        }
    };

    const onRemoveConfirmationClose = async () => {
        const payload = projectAndAffiliations[activeActionItem]?.projectID;
        const response = await deleteJetliftCase(payload);
        if (response) {
            showToast("Case deleted successfully.", "success");
            setActiveActionItem(0);
            if (activeActionItem === activeCase?.index) {
                setActiveCase((prev) => ({ ...prev, index: 0 }));
            }
            await getProjectAndAffiliationsDetails(parentProjectID || "");
            if (caseId === payload) {
                navigate(`/project-details/projectID=${parentProjectID}`);
            }
        }
    };

    const handleCaseView = async (option: any, index: number) => {
        setActiveCase((prev) => ({ ...prev, index, case: option }));
        getUpdatedSelectedProject({
            projectID: parentProjectID ?? "",
            projectName: option?.projectName,
            caseID: option?.projectID
        });
        const selectProject = projectAndAffiliations?.find((x: any) => x.projectID === option?.projectID);
        updateLiftOption({ designType: designType?.[selectProject?.liftType as keyof typeof designType] ?? "", id: selectProject?.liftType });

        if (index === 0) {
            navigate(`/project-details/projectID=${option?.projectID}`)
        } else {
            navigate(`/project-details/projectID=${parentProjectID}/caseID=${option?.projectID}`);
        }

        await getProjectAndAffiliationsDetails(parentProjectID || option?.projectID);

        if (selectProject?.liftType === 2) {
            const caseId = index === 0 ? option?.projectID : option?.projectID;
            getJetliftCalculations({
                id: caseId,
                unitSystem: 0
            });
        }
    };

    const handleCaseDuplicate = async (option: any, index: number) => {
        if (projectAndAffiliations.every((x: any) => [ProjectStatus.needReview, ProjectStatus.reviewInProgress].includes(x.status))) {
            let duplicateExists = projectAndAffiliations?.some((item: any) =>
                projectAndAffiliations?.some((other: any) =>
                    item !== other && item?.copyFrom === option?.projectID && item?.userRole?.includes("Customer")
                )
            );

            if (duplicateExists) {
                showToast("Only one copy allowed per shared case.", "warning");
                return;
            }
        }

        let caseName = updateCaseName(option?.displayCaseName, true, projectAndAffiliations);
        const isJetLift = option?.liftType === 2;
        if (isJetLift) {
            // Get parent case to access properties like customerCnxId, operatorContact, companyName
            const parentCase = filteredAffiliations?.find((x: any) => x.projectID === parentProjectID) || projectAndAffiliations?.find((x: any) => x.projectID === parentProjectID);

            const copyParams = {
                ProjectID: option?.projectID,
                ProjectName: option?.projectName || parentCase?.projectName || "",
                CaseName: option?.caseName?.trim() || "",
                DisplayCaseName: caseName,
                IsCaseLevel: true,
                customerCnxId: option?.customerCnxId || parentCase?.customerCnxId || 0,
                operatorContact: option?.operatorContact || parentCase?.operatorContact || "",
                companyName: option?.companyName || parentCase?.companyName || "",
                parentId: parentProjectID || "",
                CaseProjectId: option?.projectID || "",
            };
            await CopyJetliftProject(copyParams);
        } else {
            const copyPayload = {
                ProjectId: option?.projectID,
                caseName: option?.caseName?.trim(),
                IsCaseLevel: true,
                parentId: parentProjectID,
                DisplayCaseName: caseName,
            };

            const response = await copyMyProjects(copyPayload);
            if (response) {
                toast.success("Project copied successfully.", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    style: {
                        background: "#4CAF50",
                        color: "#fff",
                    },
                });
                getProjectAndAffiliationsDetails(parentProjectID || selectedProject?.projectID || '');
            }
        }
    };

    return (
        <>
            <div
                className={`flex flex-col items-center justify-center w-full border-[1px] rounded-[8px] border-solid border-darkcolor-400 bg-darkcolor-700`}
            >
                <div className={`flex flex-col w-full py-3 px-4 ${isComparison ? "border-b-[0]" : "border-b-[1px]"
                    } border-darkcolor-400 `}>
                    <div className={`flex ${(isReports || templateId) ? "justify-end" : "justify-between"} gap-[16px]`}>
                        {isComparison ? (
                            <div className='flex items-center gap-[12px]'>
                                <Dropdown
                                    options={case1ProductionOptions || []}
                                    selected={compareInput1 || ""}
                                    onSelect={(opt: any) => clearCompareInputs1(opt.id)}
                                    bgColor='bg-transparent'
                                    dropdownBgColor='bg-darkcolor-800'
                                    disabled={true}
                                />
                                <Dropdown
                                    options={case2ProductionOptions || []}
                                    selected={compareInput2 || ""}
                                    onSelect={(opt: any) => clearCompareInputs2(opt.id)}
                                    bgColor='bg-transparent'
                                    dropdownBgColor='bg-darkcolor-800'
                                    disabled={false}
                                    showSelectOption
                                    showCloseIcon={true}
                                    overrideEnableFlag={true}
                                />
                                <Dropdown
                                    options={case3ProductionOptions || []}
                                    selected={compareInput3 || ""}
                                    onSelect={(opt: any) => clearCompareInputs3(opt.id)}
                                    bgColor='bg-transparent'
                                    dropdownBgColor='bg-darkcolor-800'
                                    disabled={false}
                                    showSelectOption
                                    showCloseIcon={true}
                                    overrideEnableFlag={true}
                                />
                            </div>
                        )
                            : isJetlift && parentProjectID && (
                                <div className='flex gap-[12px]'>
                                    <div
                                        className={`relative flex flex-col gap-[6px] w-full rounded-[8px]`}
                                    >
                                        <div
                                            className={`relative border-darkcolor-400 border-[1px] ${isOpen
                                                ? "rounded-t-[8px] pb-2 bg-darkcolor-800 border-b-0 case-dropdown-active"
                                                : "rounded-[8px]"
                                                }`}
                                        >
                                            <button
                                                onClick={toggleDropdown}
                                                className='flex justify-between items-center gap-[8px] w-full py-2 px-4 rounded-[8px]  bg-darkcolor-800 focus:outline-none'
                                            >
                                                <span className='text-neutral-25 text-[18px] font-semibold'>
                                                    {`${activeCase?.index + 1 || 1}`}:{" "}
                                                    {projectAndAffiliations?.length &&
                                                        activeCase?.case?.caseName}
                                                    <span className='p-[8px] rounded-[4px] gap-[8px] border-[1px] border-primary-700 bg-primary-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] font-normal pt-[1px] pb-[1px] pl-[7px] pr-[7px] text-[12px] ml-2'>
                                                        {filteredAffiliations?.length}
                                                    </span>
                                                </span>
                                                {isOpen ? (
                                                    <ChevronArrowUp size={20} className='mt-2' />
                                                ) : (
                                                    <ChevronArrowDown size={20} className='mb-2' />
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        <div className='flex justify-center items-center gap-[20px]'>
                            <Button
                                label=''
                                unit={isJetlift ? "Jet lift sizing" : isComparison ? "Comparison" : "Reports"}
                                handleClick={(option) => handleClick(option)}
                                width={"100%"}
                                buttonOptions={projectHeaderButtonOptions}
                            />
                        </div>
                    </div>
                    {isJetlift && isOpen && parentProjectID && (
                        <CaseCards
                            isOpen={isOpen}
                            parentProjectID={parentProjectID || ""}
                            filteredAffiliations={filteredAffiliations}
                            activeActionItem={activeActionItem}
                            setActiveActionItem={setActiveActionItem}
                            activeCase={activeCase}
                            setActiveCase={setActiveCase}
                            projectAndAffiliations={projectAndAffiliations}
                            handleCaseDialogCreate={handleCaseDialogCreate}
                            onRemoveConfirmationClose={onRemoveConfirmationClose}
                            handleCaseDuplicate={handleCaseDuplicate}
                            handleCaseView={handleCaseView}
                        />
                    )}
                </div>
                {!isComparison && (<div className='flex justify-between items-center w-full py-3 px-4'>
                    <div className='flex gap-[12px]'>
                        <div className=''>
                            <ButtonGroup
                                buttonOptions={calculateButtonOptions}
                                handleClick={(option: any) => {
                                    if (option?.label === "Calculate") {
                                        onCalculate && onCalculate();
                                    }
                                    return;
                                }}
                            />
                        </div>
                    </div>
                    <div className='flex justify-end items-center gap-[12px] w-full'>
                        <label className="text-neutral-25 whitespace-nowrap">{LABELS?.equipmentOffering}</label>
                        <Select
                            name='equipmentOffering'
                            label=""
                            options={equipmentOptions}
                            dropdownBgColor='bg-darkcolor-800'
                            placeholder={"Select an option...."}
                            onChange={(e: any) => { updateCatalogType(e) }}
                            className="w-[250px]"
                            value={tubingInput?.catalogType?.toString()}
                        />
                    </div>
                </div>)}
            </div>
        </>
    );
};

export default ProjectHeader;